module.exports = __webpack_public_path__ + "static/img/Color.f3712b9.png";